import {Widget} from "base/assets/js/widget/Widget.js";

/**
 * автосохранение черновика
 */
export class DraftMenu extends Widget {

	bLoad = false;
	bActive = false;

	run() {
		this._on( 'Btn', 'click', ( oEvent ) => {
			if( !this.bLoad ) {
				this._load()
				.fail( ::this._redirectWrite );
				return;
			}
			this._toggle();
		} )
	}

	reload() {
		this.bActive = false;
		this._load();
	}

	_load() {
		return $.post( '/topic/draftList', ( sHtml ) => {
			// если пустой список черновиков, сразу на форму создания нового поста
			if( !sHtml ) {
				this._redirectWrite();
				return;
			}
			this._el( 'Area' ).innerHTML = sHtml;
			this._link( this._el( 'Area' ), true );
			this.bLoad = true;
			this._toggle();
		} )
	}

	_toggle() {
		this.bActive = !this.bActive;
		this._mod( '', 'draft_active', this.bActive );
	}

	_redirectWrite() {
		location.href = '/write/';
	}
}